function loadNoUiSliderAssets(callback) {
  const cssLink = document.createElement('link');
  cssLink.rel = 'stylesheet';
  cssLink.href = 'https://cdn.jsdelivr.net/npm/nouislider@15.7.1/dist/nouislider.min.css';
  document.head.appendChild(cssLink);

  const script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/nouislider@15.7.1/dist/nouislider.min.js';
  script.onload = callback;
  document.body.appendChild(script);
}

document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector("[data-section-type='infinite-scroll-products']");
  if (!section) return;

  const productContainer = section.querySelector(".infinite-product-grid");
  const filterParent = document.querySelector(".custom-product-slider-section");
  const filterForm = section.querySelector("#filter-form");

  if (!filterParent) {
    console.error("Section not found!");
    return;
  }
   if (!filterForm) {
    console.error("Filter form not found!");
    return;
  }
  const filterBtn = document.createElement("button");
filterBtn.textContent = "Filter";
 filterBtn.innerHTML = ` <svg xmlns="http://www.w3.org/2000/svg" 
       width="16" height="16" 
       fill="currentColor" 
       viewBox="0 0 16 16">
    <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 
             0 1h-3a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 
             .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 
             1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 
             0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"/>
  </svg> Filter`;
filterBtn.className = "filter-btn";
filterBtn.style.display = "none"; 
filterParent.insertAdjacentElement("afterend", filterBtn); 

filterBtn.addEventListener("click", () => {
  if (filterForm.style.display === "none" || !filterForm.style.display) {
    filterForm.style.display = "flex";
    
  } else {
    filterForm.style.display = "none";
  }
});


function handleResize() {
  if (window.innerWidth <= 608) {
    filterBtn.style.display = "flex"; 
    filterForm.style.display = "none"; 
  } else {
    filterBtn.style.display = "none"; 
    filterForm.style.display = "flex"; 
     
  }
}


handleResize();
window.addEventListener("resize", handleResize);


  const enabledMetafields = (section.dataset.enabledMetafields || '')
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);

  const storefrontToken = '50489c943f6457f7f3c9b542cf72b48e';
  const domain = 'sanaulla-international.myshopify.com';
  const collectionHandle = section.dataset.collectionHandle || 'trending';
  const initialRenderCount = 16;
  const scrollBatchSize = 50;

  let allProducts = [];
  let filteredProducts = [];
  let activeFilters = {};
  let endCursor = null;
  let hasNextPage = true;
  let renderedCount = 0;
  let allFetched = false;
  let isLoadingMore = false;

  const allFilterValues = {};
  enabledMetafields.forEach(key => allFilterValues[key] = new Set());

  Shopify.formatMoney = Shopify.formatMoney || function (cents, format = '{{amount}}') {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = (cents / 100).toFixed(2);
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  function renderSkeletons(count) {
    let skeletonHTML = '';
    for (let i = 0; i < count; i++) {
      skeletonHTML += `
        <div class="grid__item grid-product small--one-half medium-up--one-quarter skeleton">
          <div class="product-card">
            <div class="product-card__image-wrapper skeleton-image"></div>
            <div class="product-card__info">
              <div class="skeleton-text skeleton-title"></div>
              <div class="skeleton-text skeleton-price"></div>
            </div>
          </div>
        </div>`;
    }
    productContainer.insertAdjacentHTML("beforeend", skeletonHTML);
  }

  function renderFilterSkeletons() {
    filterForm.innerHTML = '<div class="skeleton-filter"></div><div class="skeleton-filter"></div><div class="skeleton-filter"></div>';
  }

  async function fetchInitialProducts() {
    productContainer.innerHTML = '';
    renderSkeletons(initialRenderCount);
    renderFilterSkeletons();
    const products = await fetchProducts(initialRenderCount);
    allProducts.push(...products);
    filteredProducts = [...allProducts];
    productContainer.innerHTML = '';
    renderInitialProducts();
    fetchRemainingProducts();
  }

  async function fetchRemainingProducts() {
    renderFilterSkeletons();
    while (hasNextPage) {
      const batch = await fetchProducts(100, endCursor);
      allProducts.push(...batch);
    }
    filteredProducts = [...allProducts];
    renderFilterForm();
    allFetched = true;
  }

  async function fetchProducts(first, afterCursor = null) {
  const query = `query GetProducts($handle: String!, $first: Int!, $cursor: String) {
    collection(handle: $handle) {
      products(first: $first, after: $cursor) {
        pageInfo { hasNextPage endCursor }
        edges {
          node {
            id title handle
            featuredImage { url altText }
            variants(first: 1) {
              edges {
                node {
                  price { amount }
                  compareAtPrice { amount }
                }
              }
            }
            designer: metafield(namespace: "custom", key: "designer") { value }
            color: metafield(namespace: "custom", key: "color") { value }
            season: metafield(namespace: "custom", key: "season") { value }
            shirt_fabric: metafield(namespace: "custom", key: "shirt_fabric") { value }
          }
        }
      }
    }
  }`;

  const variables = { handle: collectionHandle, first, cursor: afterCursor };

  const res = await fetch(`https://${domain}/api/2023-10/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontToken
    },
    body: JSON.stringify({ query, variables })
  });

  const data = await res.json();
  const edges = data.data.collection.products.edges;
  endCursor = data.data.collection.products.pageInfo.endCursor;
  hasNextPage = data.data.collection.products.pageInfo.hasNextPage;

  const newProducts = edges.map(({ node }) => {
    const variant = node.variants.edges[0]?.node;
    const price = parseFloat(variant.price.amount) * 100;
    const compareAt = variant.compareAtPrice?.amount ? parseFloat(variant.compareAtPrice.amount) * 100 : null;

    const metafields = {
      designer: node.designer?.value || '',
      color: node.color?.value || '',
      season: node.season?.value || '',
      shirt_fabric: node.shirt_fabric?.value || ''
    };

    for (const key of enabledMetafields) {
      const val = metafields[key];
      if (val) allFilterValues[key].add(val.trim());
    }

    return {
      id: node.id,
      title: node.title,
      handle: node.handle,
      image: node.featuredImage?.url,
      price,
      compareAtPrice: compareAt,
      metafields
    };
  });

  return newProducts;
}


function renderFilterForm() {
  filterForm.innerHTML = '';

 

  // Create price range slider using noUiSlider
  if (allProducts.length && typeof noUiSlider !== 'undefined') {
    const prices = allProducts.map(p => p.price);
    const minPrice = Math.min(...prices);
    const maxPrice = Math.max(...prices);

    const priceWrapper = document.createElement('div');
    priceWrapper.className = 'price-slider-wrapper';

    const priceLabel = document.createElement('label');
    priceLabel.textContent = `Price Range:`;

    const slider = document.createElement('div');
    slider.id = 'price-slider';

    const priceValues = document.createElement('div');
    priceValues.className = 'price-values';
    priceValues.innerHTML = `
      <span>Min: <strong class="price-min">${Shopify.formatMoney(minPrice)}</strong></span> -
      <span>Max: <strong class="price-max">${Shopify.formatMoney(maxPrice)}</strong></span>
    `;

    priceWrapper.appendChild(priceLabel);
    priceWrapper.appendChild(priceValues);
    priceWrapper.appendChild(slider);
    filterForm.appendChild(priceWrapper);

    noUiSlider.create(slider, {
      start: [minPrice, maxPrice],
      connect: true,
      range: {
        min: minPrice,
        max: maxPrice
      },
      step: 100,
      format: {
        to: value => Math.round(value),
        from: value => Math.round(value)
      }
    });

    slider.noUiSlider.on('update', (values) => {
      const [min, max] = values;
      priceValues.querySelector('.price-min').textContent = Shopify.formatMoney(min);
      priceValues.querySelector('.price-max').textContent = Shopify.formatMoney(max);
    });

    slider.noUiSlider.on('change', (values) => {
      const [min, max] = values;
      const fd = new FormData(filterForm);
      fd.set('filter.v.price.gte', min);
      fd.set('filter.v.price.lte', max);
      activeFilters['filter.v.price.gte'] = min;
      activeFilters['filter.v.price.lte'] = max;
      const filtered = applyFilters(allProducts);
      filteredProducts = filtered;
      renderedCount = 0;
      productContainer.innerHTML = '';
      if (filtered.length === 0) {
        productContainer.innerHTML = "<div class='filter-prod-nf'>" +
          "<img src='//cdn.shopify.com/s/files/1/0653/0842/6330/files/search-bar.png?v=1748428120' width='130px'>" +
          "<p>Oops! We couldn't find anything. </p>" +
          "<p>No results for your search. Try another term to find what you’re looking for!</p></div>";
      } else {
        renderProducts(filtered);
      }
    });

    // Inject custom black track style
    const style = document.createElement('style');
    style.textContent = `
      #price-slider .noUi-connect {
        background: gray;
      }
      #price-slider .noUi-handle {
        background: black;
        border: none;
        box-shadow: none;
      }
      #price-slider .noUi-handle:before,
      #price-slider .noUi-handle:after {
        display: none;
      }
    `;
    document.head.appendChild(style);
  }

  const labelMap = {
    designer: "Brands",
    color: "Color",
    season: "Season",
    shirt_fabric: "Shirt Fabric"
  };

    // Render dropdown filters
  Object.entries(allFilterValues).forEach(([key, values]) => {
    const label = labelMap[key] || key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

    const wrapper = document.createElement('div');
    wrapper.classList.add('filter-item-wrapper'); // custom class for individual label+select

    const labelEl = document.createElement('label');
    labelEl.textContent = `${label}: `;

    const select = document.createElement('select');
    select.name = key;
    select.classList.add('custom-dropdown');
    select.innerHTML = `<option value="">All ${label}</option>`;
    
    [...values].sort().forEach(val => {
      const opt = document.createElement('option');
      opt.value = val;
      opt.textContent = val;
      select.appendChild(opt);
    });

    wrapper.appendChild(labelEl);
    wrapper.appendChild(select);
    filterForm.appendChild(wrapper);
  });

    // Sort dropdown
  const sortWrapper = document.createElement('div');
  sortWrapper.classList.add('filter-item-wrapper');

  const sortLabel = document.createElement('label');
  sortLabel.textContent = 'Sort: ';

  const sortSelect = document.createElement('select');
  sortSelect.name = 'sort';
  sortSelect.classList.add('custom-dropdown');
  sortSelect.innerHTML = `
    <option value="">Sort By</option>
    <option value="price-asc">Price: Low to High</option>
    <option value="price-desc">Price: High to Low</option>
    <option value="az">A to Z</option>
    <option value="za">Z to A</option>
  `;

  sortWrapper.appendChild(sortLabel);
  sortWrapper.appendChild(sortSelect);
  filterForm.appendChild(sortWrapper);


  // 🔁 Add Reset Filters Button
  const resetWrapper = document.createElement('div');
  resetWrapper.className = 'filter-item-wrapper';

  const resetButton = document.createElement('button');
  resetButton.textContent = 'Reset Filters';
  resetButton.className = 'custom-dropdown';
  resetButton.style.backgroundColor = '#ed2590';
  resetButton.style.color = 'white';
  resetButton.style.border = 'none';
  resetButton.style.cursor = 'pointer';
  resetButton.style.padding = '8px';
  resetButton.style.marginTop = '19px';

  resetButton.addEventListener('click', (e) => {
    e.preventDefault();

    // ✅ Clear activeFilters
    activeFilters = {};

    // ✅ Reset dropdowns
    filterForm.querySelectorAll('select').forEach(select => {
      select.selectedIndex = 0;
    });

    // ✅ Reset price slider
    const priceSlider = document.querySelector('#price-slider')?.noUiSlider;
    if (priceSlider && allProducts.length) {
      const prices = allProducts.map(p => p.price);
      const min = Math.min(...prices);
      const max = Math.max(...prices);
      priceSlider.set([min, max]);
    }

    // ✅ Render full product list again
    filteredProducts = [...allProducts];
    renderedCount = 0;
    productContainer.innerHTML = '';
    renderProducts(filteredProducts.slice(0, initialRenderCount));
  });

  resetWrapper.appendChild(resetButton);
  filterForm.appendChild(resetWrapper);

 
}

  function applyFilters(products) {
    const min = parseInt(activeFilters['filter.v.price.gte'] || '0', 10);
    const max = parseInt(activeFilters['filter.v.price.lte'] || '100000000', 10);
    return products.filter(p => {
      const inPriceRange = p.price >= min && p.price <= max;
      return inPriceRange && Object.entries(activeFilters).every(([key, val]) => {
        if (key.includes('price')) return true;
        return val === '' || (p.metafields[key] || '').toLowerCase() === val.toLowerCase();
      });
    });
  }


  function renderProducts(products) {
  const productHTML = [];
  const modalsHTML = [];

  products.forEach(p => {
    const productId = p.id;
    const handle = p.handle;

    // Calculate savings percent
    let savingsHTML = '';
    if (p.compareAtPrice && p.compareAtPrice > p.price) {
      const savingsPercent = Math.round(((p.compareAtPrice - p.price) / p.compareAtPrice) * 100);
      savingsHTML = `<span class="price--savings">Save ${savingsPercent}%</span>`;
    }


     productHTML.push(`
      <div class="grid__item grid-product small--one-half medium-up--one-quarter">
        <a href="/products/${p.handle}" class="product-card-link">
          <div class="product-card">
            <div class="product-card__image-wrapper">
              <img src="${p.image || 'https://via.placeholder.com/300x400?text=No+Image'}" 
                  alt="${p.title}" />
            </div>
            <div class="grid-product__meta">
              <div class="grid-product__title grid-product__title--body">${p.title}</div>
              <div class="product-card__price product-card-price">
                ${
                  p.compareAtPrice && p.compareAtPrice > p.price
                    ? `<span class="original-price">USD. ${Shopify.formatMoney(p.compareAtPrice)}</span>
                      <span class="sale-price">USD. ${Shopify.formatMoney(p.price)}</span>
                      <span class="grid-product__price--savings">${savingsHTML}</span>`
                    : `<span class="regular-price">USD. ${Shopify.formatMoney(p.price)}</span>`
                }
              </div>
            </div>
          </div>
        </a>
      </div>
    `);

    modalsHTML.push(`
      <div id="QuickShopModal-${productId}" class="modal modal--square modal--quick-shop" data-product-id="${productId}">
        <div class="modal__inner">
          <div class="modal__centered">
            <div class="modal__centered-content">
              <div id="QuickShopHolder-${handle}"></div>
            </div>
            <button type="button" class="modal__close js-modal-close text-link">
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64">
                <path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"/>
              </svg>
              <span class="icon__fallback-text">Close (esc)</span>
            </button>
          </div>
        </div>
      </div>
    `);
  });

  productContainer.insertAdjacentHTML("beforeend", productHTML.join(""));
  document.getElementById("modals-container").insertAdjacentHTML("beforeend", modalsHTML.join(""));
}

document.body.addEventListener("click", function (e) {
  const button = e.target.closest(".quick-product__icon-btn");
  if (!button) return;

  const gid = button.getAttribute("data-product-id");
  const productId = gid?.split("/").pop();
  const productHandle = button.getAttribute("data-product-handle");

  console.log("Quick View Button Clicked:", productId, productHandle);

  const modal = document.querySelector(`#QuickShopModal-${productId}`);
  console.log("Modal Found:", modal);

  if (!modal) {
    console.warn("Modal not found for ID:", productId);
    return;
  }

  modal.classList.add("modal--is-active");
  document.body.classList.add("modal-open");

  const targetDiv = modal.querySelector(`#QuickShopHolder-${productHandle}`);
  if (!targetDiv) {
    console.warn("Target div not found inside modal");
    return;
  }

  // Show loader (optional)
  targetDiv.innerHTML = `<div style="padding: 2rem; text-align: center;">Loading...</div>`;

  fetch(`/products/${productHandle}`)
    .then((res) => {
      if (!res.ok) throw new Error("Failed to fetch product page");
      return res.text();
    })
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // Yahan pe correct selector lagao based on your product page layout
      const productSection =
        doc.querySelector(`#ProductSection-${productId}`) ||
        doc.querySelector(".product-single") ||
        doc.querySelector(".product-section") ||
        doc.querySelector("main");

      if (!productSection) {
        console.error("Product section not found in fetched HTML");
        targetDiv.innerHTML =
          "<div style='padding: 2rem; color: red;'>Quick view content not found.</div>";
        return;
      }

      // Inject selected content
      targetDiv.innerHTML = productSection.outerHTML;

      // Re-execute any <script> tags inside product content
      const scripts = productSection.querySelectorAll("script");
      scripts.forEach((oldScript) => {
        const newScript = document.createElement("script");
        if (oldScript.src) {
          newScript.src = oldScript.src;
        } else {
          newScript.textContent = oldScript.textContent;
        }
        document.body.appendChild(newScript);
      });
    })
    .catch((err) => {
      console.error("Failed to load quick view content:", err);
      targetDiv.innerHTML = `<div style="padding: 2rem; text-align: center; color: red;">Failed to load product details. Please try again.</div>`;
    });
});

  document.addEventListener("click", function (e) {
  if (e.target.closest(".js-modal-close")) {
    const modal = e.target.closest(".modal");
    if (modal) {
      modal.classList.remove("modal--is-active");
      document.body.classList.remove("modal-open");
    }
  }
});

  function renderInitialProducts() {
    const toRender = filteredProducts.slice(0, initialRenderCount);
    renderedCount = toRender.length;
    renderProducts(toRender);
  }

function renderMoreProducts() {
  if (isLoadingMore) return;
  isLoadingMore = true;
  renderSkeletons(scrollBatchSize);

  setTimeout(() => {
    const remaining = filteredProducts.length - renderedCount;
    let nextBatch;

    if (remaining >= scrollBatchSize) {
      nextBatch = filteredProducts.slice(renderedCount, renderedCount + scrollBatchSize);
      renderedCount += scrollBatchSize;
    } else {
      // If remaining < batch, take the remaining first
      nextBatch = filteredProducts.slice(renderedCount);
      // Then loop from beginning to fill rest of batch
      const loopFill = scrollBatchSize - nextBatch.length;
      nextBatch = nextBatch.concat(filteredProducts.slice(0, loopFill));
      renderedCount = loopFill;
    }

    const skeletons = productContainer.querySelectorAll('.skeleton');
    skeletons.forEach(s => s.remove());
    renderProducts(nextBatch);
    isLoadingMore = false;
  }, 600);
}

 filterForm.addEventListener("change", () => {
    const fd = new FormData(filterForm);
    activeFilters = Object.fromEntries([...fd.entries()].filter(([k, v]) => k !== 'sort' && v));
    const sortOption = fd.get('sort');

    const filtered = applyFilters(allProducts);

    // Sorting logic
    switch (sortOption) {
      case 'price-asc':
        filtered.sort((a, b) => a.price - b.price);
        break;
      case 'price-desc':
        filtered.sort((a, b) => b.price - a.price);
        break;
      case 'az':
        filtered.sort((a, b) => a.title.localeCompare(b.title));
        break;
      case 'za':
        filtered.sort((a, b) => b.title.localeCompare(a.title));
        break;
    }

    filteredProducts = filtered;
    renderedCount = 0;
    productContainer.innerHTML = '';

    if (filtered.length === 0) {
      productContainer.innerHTML = "<div class='filter-prod-nf'>" +
        "<img src='//cdn.shopify.com/s/files/1/0653/0842/6330/files/search-bar.png?v=1748428120' width='130px'>" +
        "<p>Oops! We couldn't find anything. </p>" +
        "<p>No results for your search. Try another term to find what you’re looking for!</p></div>";
    } else {
      renderProducts(filtered);
    }
  });

  window.addEventListener("scroll", () => {
    if (!allFetched || (activeFilters && Object.keys(activeFilters).length > 0)) return;
    if (window.scrollY + window.innerHeight >= document.body.scrollHeight - 500) {
      renderMoreProducts();
    }
  });

  fetchInitialProducts();
});
